"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keybordActions = exports.default = void 0;
var keybordActions = {
  insertNote: 'insertNote',
  setNotePitch: 'setNotePitch',
  setNoteTick: 'setNoteTick',
  setNoteSemitone: 'setNoteSemitone',
  setNoteDots: 'setNoteDots',
  setNoteSlur: 'setNoteSlur',
  reset: 'reset',
  remove: 'remove',
  undo: 'undo',
  redo: 'redo',
  piano: 'piano',
  dore: 'dore',
  play: 'play'
};
exports.keybordActions = keybordActions;
var _default = [[{
  action: keybordActions.insertNote,
  text: '1',
  params: {
    noteType: 'NORMAL',
    num: 1,
    octaveShift: 0
  }
}, {
  action: keybordActions.insertNote,
  text: '2',
  params: {
    noteType: 'NORMAL',
    num: 2,
    octaveShift: 0
  }
}, {
  action: keybordActions.insertNote,
  text: '3',
  params: {
    noteType: 'NORMAL',
    num: 3,
    octaveShift: 0
  }
}, {
  action: keybordActions.insertNote,
  text: '4',
  params: {
    noteType: 'NORMAL',
    num: 4,
    octaveShift: 0
  }
}, {
  action: keybordActions.insertNote,
  text: '5',
  params: {
    noteType: 'NORMAL',
    num: 5,
    octaveShift: 0
  }
}, {
  action: keybordActions.insertNote,
  text: '6',
  params: {
    noteType: 'NORMAL',
    num: 6,
    octaveShift: 0
  }
}, {
  action: keybordActions.insertNote,
  text: '7',
  params: {
    noteType: 'NORMAL',
    num: 7,
    octaveShift: 0
  }
}, {
  action: keybordActions.insertNote,
  text: '0',
  params: {
    noteType: 'REST',
    text: '0'
  }
}, {
  action: keybordActions.insertNote,
  text: 'X',
  params: {
    noteType: 'TAP',
    text: 'X'
  }
}, {
  action: keybordActions.setNoteDots,
  text: '.',
  class: 'large-text'
}, {
  action: keybordActions.undo,
  text: '撤销',
  lock: false,
  class: 'action-btn green-btn'
}, {
  action: keybordActions.redo,
  text: '重做',
  lock: false,
  class: 'action-btn green-btn'
}, {
  action: keybordActions.remove,
  text: '删除',
  class: 'action-btn orange-btn'
}], [{
  action: keybordActions.setNotePitch,
  params: {
    type: 'DECREMENT'
  },
  text: '↓'
}, {
  action: keybordActions.setNotePitch,
  params: {
    type: 'INCREMENT'
  },
  text: '↑'
}, {
  action: keybordActions.setNoteTick,
  params: {
    type: 'DECREMENT'
  },
  text: '减时',
  class: 'action-btn'
}, {
  action: keybordActions.setNoteTick,
  params: {
    type: 'INCREMENT'
  },
  text: '增时',
  class: 'action-btn'
}, {
  action: keybordActions.setNoteSemitone,
  params: {
    num: -1,
    den: 1
  },
  text: '♭'
}, {
  action: keybordActions.setNoteSemitone,
  params: {
    num: 0,
    den: 1
  },
  text: '♮'
}, {
  action: keybordActions.setNoteSemitone,
  params: {
    num: 1,
    den: 1
  },
  text: '♯'
}, {
  action: keybordActions.setNoteSlur,
  params: {
    type: 'SLUR',
    selectType: 'NOTE',
    message: '连音线(连奏线):请选择两音符,再次点击按钮取消操作'
  },
  lock: false,
  text: '连音(奏)线',
  class: 'action-btn small-text'
}, {
  action: keybordActions.setNoteSlur,
  params: {
    type: 'TUPLET',
    selectType: 'NOTE',
    message: '3连音：请选择两音符,再次点击按钮取消操作'
  },
  lock: false,
  text: ' 3连音',
  class: 'action-btn small-text'
}, {
  action: keybordActions.reset,
  text: '重置',
  lock: false,
  class: 'action-btn green-btn'
}, {
  action: keybordActions.piano,
  text: '钢琴',
  class: 'action-btn-green'
}, {
  action: keybordActions.dore,
  text: '唱名',
  class: 'action-btn'
}, {
  action: keybordActions.play,
  text: '播放',
  class: 'action-btn yellow-btn'
}]];
exports.default = _default;